/** Fester Fehlercode des Servers, wenn am LinkedIn-Konto Arbeitstage oder -zeiten fehlen (Start verweigert). */
export const WORK_WINDOW_MISSING_CODE = 'ACCOUNT_WORK_WINDOW_MISSING';

export const isWorkWindowMissingError = (code: string | null | undefined): boolean => code === WORK_WINDOW_MISSING_CODE;
